import { Button, Modal, Paragraph } from '@asgard/ui-library';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { useJoinUsLoggedInModal } from './JoinUsLoggedInModal.hooks';
import { JoinUsLoggedInModalProps } from './JoinUsLoggedInModal.types';

export const JoinUsLoggedInModal: React.FC<JoinUsLoggedInModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t, isApplying, onApplyClick } = useJoinUsLoggedInModal({ onClose });

  return (
    <Modal
      title={t('modal.apply.title')}
      closeable={false}
      isOpen={isOpen}
      buttonsSlot={
        <>
          <Button
            label={t('modal.actions.apply')}
            startIcon={faCheckCircle}
            size="xs"
            onClick={onApplyClick}
            isLoading={isApplying}
            loadingText={t('modal.actions.applying')}
          />

          <Button
            label={t('modal.actions.cancel')}
            startIcon={faTimesCircle}
            variant="bare"
            size="xs"
            onClick={onClose}
          />
        </>
      }
    >
      <Paragraph>{t('modal.apply.desc')}</Paragraph>
    </Modal>
  );
};
